import * as o from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/ArrowUpRight.es.js";
const r = o.forwardRef((t, e) => /* @__PURE__ */ o.createElement(a, { ref: e, ...t, weights: i }));
r.displayName = "ArrowUpRightIcon";
const c = r;
export {
  c as ArrowUpRight,
  r as ArrowUpRightIcon
};
